/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProfileSetTypes model module.
 * @module model/ProfileSetTypes
 * @version 1.0.0
 */
class ProfileSetTypes {
    /**
     * Constructs a new <code>ProfileSetTypes</code>.
     * a profileset type
     * @alias module:model/ProfileSetTypes
     */
    constructor() { 
        
        ProfileSetTypes.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileSetTypes</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileSetTypes} obj Optional instance to populate.
     * @return {module:model/ProfileSetTypes} The populated <code>ProfileSetTypes</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileSetTypes();

            if (data.hasOwnProperty('tag')) {
                obj['tag'] = ApiClient.convertToType(data['tag'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('details')) {
                obj['details'] = ApiClient.convertToType(data['details'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} tag
 */
ProfileSetTypes.prototype['tag'] = undefined;

/**
 * @member {String} name
 */
ProfileSetTypes.prototype['name'] = undefined;

/**
 * @member {String} details
 */
ProfileSetTypes.prototype['details'] = undefined;






export default ProfileSetTypes;

